import React from 'react'
import {Link} from 'react-router-dom'

const ErrorPage = ({title, icon, description}) => (
  <section className="hero is-fullheight">
    <div className="hero-body">
      <div className="container tw:text-center">
        <div className="columns is-tablet is-centered">
          <div className="column is-one-third">
            <h1 className="title is-4">{title}</h1>
            {icon && (
              <span className="icon is-large">
                <i className={`fa-3x ${icon}`} />
              </span>
            )}
            <p className="tw:mt-4">{description}</p>
            <p className=" tw:mt-4 ">
              <Link className="button is-primary" to="/">
                Go back to Start
              </Link>
            </p>
            <p className=" tw:mt-4 ">
              <a href="mailto:contact@retraced.com?subject=Problem%20using%20Dashboard">
                or contact us if you need help
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
)
export default ErrorPage
